import React from 'react';
import { useIntl } from 'react-intl';

const DomainList = ({ domains, activeDomain, onDomainSelect }) => {
  const intl = useIntl();

  return (
    <div className="w-1/4 pr-8 border-r border-slate-200">
      <div className="flex items-center gap-3 mb-5">
        <span className="w-8 h-px bg-[#16A34A]" />
        <h3 className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#16A34A]">
          {intl.formatMessage({ id: "menu.domains", defaultMessage: "Secteurs d'activités" })}
        </h3>
      </div>
      <ul className="space-y-1">
        {domains.map((domain, idx) => (
          <li key={idx}>
            <button
              className={`relative block w-full text-left px-3 py-2.5 text-sm font-semibold transition-colors duration-200 border-l-2 ${
                activeDomain === domain
                  ? 'border-[#16A34A] bg-[#16A34A]/5 text-[#16A34A]'
                  : 'border-transparent text-[#0a1628] hover:text-[#16A34A] hover:bg-slate-50'
              }`}
              onMouseEnter={() => onDomainSelect(domain)}
              onClick={() => onDomainSelect(domain)}
            >
              {domain}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DomainList;